import React from 'react';
import './Homepage.css';

// Import all the section components
import Navbar from './Navbar/Navbar';
import Headlines from './Headlines/Headlines';
import ImageSlider from './ImageSlider/ImageSlider';
import GovernorViceChancellor from './GovernorViceChancellor/GovernorViceChancellor';
import NotificationVCSection from './NotificationVCSection/NotificationVCSection';
import StatsSection from './StatsSection/StatsSection';
import CollegesSection from './CollegesSection/CollegesSection';
import ThemeAndVision from './ThemeAndVision/ThemeAndVision';
import Gallery from './Gallery/Gallery';
import Footer from './Footer/Footer';
import HomeQuickLinks from '../NewSectionForAcadeimcResarchAdminsion/HomeQuickLinks';
import HomeLeadership from './Leardership/HomeLeadership';
import CampusLife from './CampusLife/CampusLife';
import CampusDigitalServices from '../Homepage/Lms_Feedback_Alumni/CampusDigitalServices';
import AchivementsEvnets from './UpcomingEvents/AchivementsEvnets';

const Homepage = () => {
  return (
    <div className="homepage">
      <Navbar />
      <Headlines />
      <div className="homepage-content">
        <ImageSlider />
        <GovernorViceChancellor />

        <HomeLeadership />
        <NotificationVCSection />
        <HomeQuickLinks />
        <CollegesSection />

        <div id="campus-life">
          <CampusLife />
        </div>
        <AchivementsEvnets/>
        <ThemeAndVision />
        <CampusDigitalServices />

        <StatsSection />
        <Gallery />
      </div>
      <Footer />
    </div>
  );
};

export default Homepage;